import { WallPin } from '~/models/WallPin'
import { Page } from '~/models/PaginatedItems'
import { BasePaginatedMemoryCache } from '~/passporter-services/basePaginatedMemoryCache'

export class WallPinCache extends BasePaginatedMemoryCache<WallPin> {
	private getTripPageKey(tripId: string) {
		return `trip-${tripId}`
	}

	public setTripPage(tripId: string, wallPinPage: Page<WallPin>, page: number, pageSize: number) {
		const key = this.getTripPageKey(tripId)
		this.setPage(key, { ...wallPinPage, page, pageSize })
	}

	public getTripPage(tripId: string, page: number, pageSize: number): Page<WallPin> | undefined {
		const key = this.getTripPageKey(tripId)
		return this.getPage(key, page, pageSize)
	}

	public deleteTripPages(tripId: string) {
		const key = this.getTripPageKey(tripId)
		this.delete(key)
	}
}
